import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import InputField from '../InputField';
import Card from './index.jsx';

const FormCard = props => {
  return (
    <div className="card-form">
      <Form>
        <InputField
          readOnly
          label="Rx BIN:"
          inputType="text"
          value={ props.cardBin }
          onChange={ function () {} }
        />
        <InputField
          readOnly
          label="PCN:"
          inputType="text"
          value={ props.cardPcn }
          onChange={ function () {} }
        />
        <InputField
          readOnly
          label="Group:"
          inputType="text"
          value={ props.groupId }
          onChange={ function () {} }
        />
        <InputField
          readOnly
          label="ID:"
          inputType="text"
          value={ props.cardId }
          onChange={ function () {} }
        />
      </Form>
      <Card
        selectedProduct={ props.selectedProduct }
        cardBin={ props.cardBin }
        cardPcn={ props.cardPcn }
        cardId={ props.cardId }
        groupId={ props.groupId }
        front
        hideButton
      />
    </div>
  );
};

FormCard.propTypes = {
  cardId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
};

export default FormCard;
